import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/delivery.scss";
import { Link } from "react-router-dom";
import { FaTruck, FaBox, FaClock, FaPhone, FaEnvelope } from "react-icons/fa";

function Delivery() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="info-page delivery">
      <Header />

      <div className="info-page__breadcrumb">
        <Link onClick={toTop} to="/">
          Home
        </Link>
        <span>/</span>
        <span>Shipping Information</span>
      </div>

      <div className="info-page__content">
        <div className="info-page__main">
          <h1 className="info-page__title">Shipping Information</h1>

          <section className="info-section">
            <h2 className="info-section__title">Shipping Options</h2>
            <p className="info-section__intro">
              We offer several shipping options to meet your needs. Orders are
              processed within 1-2 business days.
            </p>

            <div className="shipping-options">
              <div className="shipping-option">
                <div className="shipping-option__icon">
                  <FaTruck />
                </div>
                <div className="shipping-option__content">
                  <h3>Standard Shipping</h3>
                  <p className="shipping-option__time">5-7 business days</p>
                  <p className="shipping-option__price">$7.99</p>
                  <p className="shipping-option__note">
                    Free on orders over $50
                  </p>
                </div>
              </div>

              <div className="shipping-option">
                <div className="shipping-option__icon">
                  <FaClock />
                </div>
                <div className="shipping-option__content">
                  <h3>Express Shipping</h3>
                  <p className="shipping-option__time">2-3 business days</p>
                  <p className="shipping-option__price">$14.99</p>
                </div>
              </div>

              <div className="shipping-option">
                <div className="shipping-option__icon">
                  <FaBox />
                </div>
                <div className="shipping-option__content">
                  <h3>Priority Shipping</h3>
                  <p className="shipping-option__time">1-2 business days</p>
                  <p className="shipping-option__price">$24.99</p>
                </div>
              </div>
            </div>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Order Processing</h2>
            <p>
              Orders placed before 2 PM EST Monday through Friday are processed
              the same day. Orders placed after 2 PM EST or on weekends will be
              processed the next business day.
            </p>
            <p>
              You will receive a confirmation email with tracking information
              once your order ships. Please allow 24 hours for tracking updates
              to appear.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">
              Shipping to Alaska and Hawaii
            </h2>
            <p>
              Standard shipping to Alaska and Hawaii takes 7-10 business days.
              Express and Priority options are available at additional cost.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">International Shipping</h2>
            <p>
              We currently ship to select international destinations.
              International orders may be subject to customs duties and taxes,
              which are the responsibility of the recipient.
            </p>
            <p>Please allow 2-3 weeks for international delivery.</p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Shipping to PO Boxes</h2>
            <p>
              We can ship to PO Boxes using Standard Shipping. Please note that
              APO/FPO addresses are also supported with Standard Shipping rates.
            </p>
          </section>

          <section className="info-section">
            <h2 className="info-section__title">Package Safety</h2>
            <p>
              All packages are carefully packaged to ensure your products arrive
              in perfect condition. If your order arrives damaged, please
              contact our customer service team within 5 days of delivery.
            </p>
          </section>
        </div>

        <aside className="info-page__sidebar">
          <div className="sidebar-card">
            <h3 className="sidebar-card__title">Need Help?</h3>
            <p className="sidebar-card__text">
              Contact our customer service team for assistance with your order
              or shipping questions.
            </p>
            <div className="contact-info">
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <span>split@petmorvanto.club</span>
              </div>
              <div className="contact-item">
                <FaClock className="contact-icon" />
                <span>Mon-Fri: 9AM-5PM EST</span>
              </div>
            </div>
          </div>

          <div className="sidebar-card">
            <h3 className="sidebar-card__title">Quick Links</h3>
            <ul className="sidebar-links">
              <li>
                <Link to="/returns" onClick={toTop}>
                  Return Policy
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={toTop}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </aside>
      </div>

      <Footer />
    </div>
  );
}

export default Delivery;
